export default "__VITE_ASSET__ZU$eu_Hd__"